export enum HoldingStatus {
  Vacation = 'vacation',
  Hospital = 'hospital',
  Active = 'active',
}
